$(function () {
  //リンク自動付与
  $('.js-img-link').each(function () {
    var href = $(this).attr('src');
    if (STATE.browserMode !== 'pc') $(this).after('<p class="u-ta-right c-mini-txt u-none u-block-sp u-mt-5"><a href="' + href + '"target="_blank"><span class="c-link">画像を拡大してみる</span></a>');
  });
});